import { WithRef } from '../../../types';
import IconBase, { CastProductIconProps, getStrokeWidth } from '../IconBase';

const DEFAULT_PRESET_BACKGROUND = '#89BAFA';

export const CastCostMonitoring = ({
  ref,
  variant,
  color = 'currentColor',
  ...props
}: WithRef<SVGSVGElement, CastProductIconProps>) => {
  const strokeWidth = props.strokeWidth ?? getStrokeWidth(props.weight);
  const isPreset = variant === 'preset';
  const fill = isPreset
    ? props.fill ?? DEFAULT_PRESET_BACKGROUND
    : props.fill ?? 'none';

  return (
    <IconBase
      ref={ref}
      {...props}
      color={color}
      fill="none"
      viewBox="0 0 25 27"
    >
      <path
        d="M24.2299 18.6688V8.33169C24.2299 7.20277 23.6277 6.15734 22.6478 5.59288L13.696 0.423342C12.7181 -0.141114 11.5117 -0.141114 10.5339 0.423342L1.58207 5.59288C0.604208 6.15734 0 7.20277 0 8.33169V18.6688C0 19.7977 0.60222 20.8431 1.58207 21.4076L10.5339 26.5771C11.5117 27.1416 12.7181 27.1416 13.696 26.5771L22.6478 21.4076C23.6257 20.8431 24.2299 19.7977 24.2299 18.6688Z"
        fill={fill}
      />
      <mask
        id="mask0_18456_2688"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="25"
        height="28"
      >
        <path
          d="M24.2299 18.6688V8.33169C24.2299 7.20277 23.6277 6.15734 22.6478 5.59288L13.696 0.423342C12.7181 -0.141114 11.5117 -0.141114 10.5339 0.423342L1.58207 5.59288C0.604208 6.15734 0 7.20277 0 8.33169V18.6688C0 19.7977 0.60222 20.8431 1.58207 21.4076L10.5339 26.5771C11.5117 27.1416 12.7181 27.1416 13.696 26.5771L22.6478 21.4076C23.6257 20.8431 24.2299 19.7977 24.2299 18.6688Z"
          fill={color}
        />
      </mask>
      <g mask="url(#mask0_18456_2688)">
        <path
          d="M12.1152 26.98V20.2764"
          stroke={color}
          strokeWidth={strokeWidth}
          strokeMiterlimit="10"
        />
        <path
          d="M24.9435 8.65393L14.4092 14.8249L9.81999 12.1756L-0.509277 18.326"
          stroke={color}
          strokeWidth={strokeWidth}
          strokeMiterlimit="10"
        />
        <path
          d="M5.36824 14.6036C4.72397 9.01981 9.58889 6.72119 12.1132 6.72119C15.2933 6.72119 17.9625 8.91343 18.6939 11.8689C18.8231 12.3916 18.8907 12.9362 18.8907 13.4986C18.8907 17.2411 15.8557 20.2761 12.1132 20.2761C9.87824 20.1874 7.73063 19.3283 6.44206 17.1807"
          stroke={color}
          strokeWidth={strokeWidth}
          strokeMiterlimit="10"
        />
      </g>
    </IconBase>
  );
};

CastCostMonitoring.displayName = 'CastCostMonitoring';
